export default {
        "home.title.back_office": "Back Office",
    "home.title.team_member_portal": "Team Member Portal",
    "home.title.start_page_title": "What would you like to do today?",

    "home.label.show_descriptions": "Show Descriptions",

    "home.placeholder.feature_finder": "Feature Finder",

    "profile.page_title": "Profile",

    "profile.link.title.profile": "Profile",
    "profile.link.description.profile": "Update your name, email address, and password.",

    "profile.button.update": "Update profile",
    "profile.button.password_update": "Update password",

    "profile.success.message.password_updated": "Your password was successfully updated",
    "profile.success.message.profile_updated": "Your profile was successfully updated",

    "settings.page_title": "Settings",
    "settings.page.invitations.title": "Team Invitations",
    "settings.page.team.title": "The Team At ",
    "settings.page.invitations.search_results": "Search Results",
    "settings.page.search_results": "Search Results",
    "settings.page.team.invite": "Invite Team Member",
    "settings.page.team.new": "Add Team Member",
    "settings.page.team.edit": "Edit Member Roles",
    "settings.page.team.view_self": "Your Roles",
    "settings.page.view.invitation_title": "View Invitation",

    "settings.link.title.profile": "Profile",
    "settings.link.title.billing": "Billing",
    "settings.link.title.appearance": "Appearance",
    "settings.link.title.security": "Security",
    "settings.link.title.organization": "Organization",
    "settings.link.title.team": "Team",
    "settings.link.retry": "Click here to retry",

    "settings.checkbox.all": "Check All",
    "settings.checkbox.actions_label": "with selected",

    "settings.label.roles": "Roles",
    "settings.label.user_email": "Member Email Address",

    "settings.link.description.profile": "Update your name, email address, and password.",
    "settings.link.description.billing": "Ullamcorper id at suspendisse nec id volutpat vestibulum enim. Interdum blandit.",
    "settings.link.description.appearance": "Ullamcorper id at suspendisse nec id volutpat vestibulum enim. Interdum blandit.",
    "settings.link.description.security": "Ullamcorper id at suspendisse nec id volutpat vestibulum enim. Interdum blandit.",
    "settings.link.description.organization": "Update your organization's info.",

};
